'use client';

import { motion } from 'motion/react';

interface FaqItem {
  q: string;
  a: string;
}

export default function PhetFaqAccordion({ items }: { items: FaqItem[] }) {
  return (
    <dl className="space-y-4">
      {items.map((item, i) => (
        <motion.div
          key={item.q}
          className="rounded-[18px] border border-[#E3E8F2] bg-white p-6 transition-all duration-200 hover:border-[#E8740C]/30 hover:shadow-[0_4px_20px_rgba(232,116,12,0.06)]"
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.35, delay: i * 0.06 }}
        >
          <dt className="emphasize-text text-[15px] text-[#0D1929]">{item.q}</dt>
          <dd className="display-text mt-2.5 text-sm leading-[1.75] text-[#566070]">{item.a}</dd>
        </motion.div>
      ))}
    </dl>
  );
}
